<template>
  <section class="w city-list--w">
    <div
      v-for="item in cityList"
      :key="item.title"
      class="same-alphabet-group"
      :index="item.title"
    >
      <dl>
        <dt :ref="'g' + item.title">{{ item.title }}</dt>
        <dd
          v-for="obj,i in item.children"
          :key="i"
          :class="{on: cityInfo.cityCode === obj.ID}"
          :data-code="obj.ID"
          @click="handle(obj)"
        >
          {{ obj.NAME }}
        </dd>
      </dl>
    </div>
    <div class="alphabet-nav">
      <ul>
        <li
          v-for="item in cityList"
          :key="item.title"
          :index="item.title"
          :class="{on: selectedAlpha == item.title}"
          @click="scrollAphaGroupInView(item.title)"
        >
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import {isNullOrEmpty} from '@/utils'
import {getYRCityList} from './service'
import {changeCityCode2ProvinceCode, changePrivinceCodeToCityCode} from '@/utils/cityPollyfill'
export default {
  props: {
    cityCode: {type: String, default: ''},
  },
  data() {
    const cityInfo = {
      cityCode: '320100',
      cityName: '南京',
      PINYIN: 'NANJING',
    }
    return {
      cityListInitial: [],
      cityList: [],
      cityInfo,
      selectedAlpha: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      try {
        let {cityList, cityListInitial} = await getYRCityList()
        this.cityList = cityList
        this.cityListInitial = cityListInitial
        // 使用路由条跳转 或 组件传参
        // 城市参数有可能不匹配，这里做转换
        let cityCode = changeCityCode2ProvinceCode(this.cityCode).toString()

        let cityInfo = cityListInitial.find((x) => x.ID === cityCode)
        if (cityInfo) {
          this.cityInfo.cityCode = cityCode
          this.cityInfo.cityName = cityInfo.NAME
          this.cityInfo.PINYIN = cityInfo.PINYIN
          this.selectedAlpha = this.cityInfo.PINYIN.substr(0, 1)
        }
        this.$nextTick(() => {
          this.scrollAphaGroupInView(this.selectedAlpha, false)
        })
      } catch (error) {
        this.$$toast(JSON.stringify(error))
      }
    },
    scrollAphaGroupInView(alphabet, useAnimation = true) {
      if (isNullOrEmpty(alphabet)) return
      this.$refs['g' + alphabet][0].scrollIntoView(
        useAnimation ? {behavior: 'smooth'} : {},
      )
      this.selectedAlpha = alphabet
    },
    handle(cityInfo) {
      // 选择完毕再对城市编码转换处理
      this.$emit('citySelected', {
        cityId: changePrivinceCodeToCityCode(cityInfo.ID).toString(),
        cityName: cityInfo.NAME,
        PINYIN: cityInfo.PINYIN,
      })
    },
  },
}
</script>
<style lang="scss" scoped src="./style.scss"></style>
